import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import SidebarTest from "../layout/common/SidebarTest";
import ContentBody from "../layout/verifications/ContentBody";

const VerificationRequests = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState("createDate");
  const [sortType, setSortType] = useState(true);
  const [verificationList, setVerificationList] = useState([]);
  const [statusRecord, setStatusRecord] = useState(false);
  const [perPageRecords, setPerPageRecords] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [statusChange, setStatusChange] = useState(null);

  // server side pagination
  const onChangePageNumberHandler = (e) => {
    setPageNumber(e);
  };

  const sortOnClickHandler = (e) => {
    setSortBy(e);
  };

  const sortTypeOnClickHandler = (e) => {
    setSortType(e);
  };

  const onStatusRecordChangeHandler = (val) => {
    setStatusRecord(!statusRecord);
  };

  const pageChange = (val) => {
    setPerPageRecords(val);
  };

  const searchValueChange = (val) => {
    setSearchValue(val);
  };

  let pageCount = 0;
  if (
    verificationList &&
    verificationList.totalUsers &&
    verificationList.totalUsers > 0
  ) {
    pageCount = Math.ceil(verificationList.totalUsers / perPageRecords);
  }

  useEffect(() => {
    const query = {
      sortby: sortBy,
      sorttype: sortType,
      perpage: perPageRecords,
      currentpage: pageNumber + 1,
      search: searchValue,
      statusChange: statusChange,
    };
    (async () => {
      const data = await fetch(
        process.env.REACT_APP_API_URL + "verification-listing",
        {
          method: "POST",
          body: JSON.stringify(query),
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      const response = await data.json();
      setVerificationList(response);
    })();
  }, [
    pageNumber,
    sortBy,
    statusRecord,
    perPageRecords,
    searchValue,
    sortType,
    statusChange,
  ]);

  const statusChangeHandler = (e) => {
    setStatusChange(e);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Verification Requests</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <ContentBody
        verificationList={verificationList}
        pageNumber={pageNumber}
        onChangePageNumber={onChangePageNumberHandler}
        dataPerPage={perPageRecords}
        pageCount={pageCount}
        onChangeSortClick={sortOnClickHandler}
        onChangeSortType={sortTypeOnClickHandler}
        onStatusRecordChange={onStatusRecordChangeHandler}
        onSearchChang={searchValueChange}
        onPerPageChange={pageChange}
        onChangeStatus={statusChangeHandler}
        statusChange={statusChange}
      />
      <Footer />
    </React.Fragment>
  );
};

export default VerificationRequests;
